import { createContext, Context, useState, PropsWithChildren } from 'react'
import { userManager } from 'auth/services/auth.service'
import React from 'react'

interface IAuthContext {
	isAuthenticated: boolean
	loadingAuth: boolean
	setLoadingAuth: Function
}

const AuthContext: Context<IAuthContext> = createContext<IAuthContext>({
	isAuthenticated: false,
	loadingAuth: false,
	setLoadingAuth: () => {},
})

export function UseAuthProvider({ children }: PropsWithChildren<any>) {
	//Add new state for loadingAuth prop - boolean
	const [loadingAuth, setLoadingAuth] = useState<boolean>(false)

	const checkAuth: any = React.useCallback(async () => {
		const user = await userManager.getUser()
		if (!Boolean(user) || user?.expired) {
			return setIsAuthenticated(false)
		}
		return setIsAuthenticated(true)
	}, [])

	const [isAuthenticated, setIsAuthenticated] = useState<boolean>(checkAuth)

	return (
		<AuthContext.Provider
			value={{ isAuthenticated, loadingAuth, setLoadingAuth }}>
			{children}
		</AuthContext.Provider>
	)
}

export default AuthContext
